"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var format = _interopRequireWildcard(require("@/utils/format"));
var _tip = require("@/api/tip");
var _enum = require("@/utils/enum");
var _vuex = require("vuex");
var _lodash = require("lodash");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      configSystem: process.env.VUE_APP_CONFIG_SYSTEM,
      ORDER_TYPE: _enum.ORDER_TYPE,
      formData: {},
      listQuery: {},
      isLoading: false,
      loadingButton: false,
      tip: {},
      dialogStatus: "",
      dialogVisible: false,
      rules: {
        money: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập số tiền"
        }
      },
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  watch: {
    areas: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        if (newValue.length && !(0, _lodash.isEqual)(newValue, oldValue)) {
          this.$set(this.listQuery, "areaId", newValue[0].id);
          this.getData();
        }
      }
    }
  },
  created: function created() {
    this.$store.dispatch("area/fetchList");
  },
  methods: {
    formatVND: function formatVND(n) {
      return format.formatCurrency(n);
    },
    editData: function editData() {
      var _this = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.loadingButton = true;
          var data = {
            tip: _this.formData
          };
          _tip.tipApi.update(_this.formData.id, data).then(function () {
            _this.$message({
              type: "success",
              message: "Cập nhật thành công"
            });
            _this.dialogVisible = false;
            _this.getData();
          }).finally(function () {
            _this.loadingButton = false;
          });
        }
      });
    },
    deleteData: function () {
      var _deleteData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$confirm("Tip này sẽ bị xoá. Bạn có muốn tiếp tục?", "Cảnh báo", {
                confirmButtonText: "OK",
                cancelButtonText: "Đóng",
                type: "warning"
              });
            case 2:
              _tip.tipApi.remove(this.formData.id).then(function () {
                _this2.$message({
                  type: "success",
                  message: "Xoá thành công"
                });
                _this2.dialogVisible = false;
                _this2.getData();
              }).finally(function () {
                _this2.loadingButton = false;
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function deleteData() {
        return _deleteData.apply(this, arguments);
      }
      return deleteData;
    }(),
    handleCreate: function handleCreate() {
      var _this3 = this;
      this.dialogStatus = "create";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs["form"].resetFields();
        _this3.formData = {};
      });
    },
    createData: function createData() {
      var _this4 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this4.loadingButton = true;
          var data = {
            tip: _this4.formData,
            areaId: _this4.listQuery.areaId
          };
          _tip.tipApi.create(data).then(function () {
            _this4.$message({
              type: "success",
              message: "Tạo thành công"
            });
            _this4.dialogVisible = false;
            _this4.getData();
          }).finally(function () {
            _this4.loadingButton = false;
          });
        }
      });
    },
    handleEdit: function handleEdit(item) {
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.formData = (0, _objectSpread2.default)({}, item);
    },
    getData: function getData() {
      var _this5 = this;
      this.isLoading = true;
      _tip.tipApi.findAll(this.listQuery).then(function (res) {
        _this5.tableData = res.data;
      }).finally(function () {
        _this5.isLoading = false;
      });
    }
  }
};